class taxationInvoicesController {
  /* @ngInject */
  constructor(InvoicesService, $log, $filter, NewUserInstrumentStore, NewUserInstrumentActions, NewTokenService, StoreStates, $rootScope) {
    const that = this;
    let wallet = '';

    that.movementsList = [];
    that.processedRecord = [];
    that.loading = false;
    that.filterMonth = 0;
    that.filterType = 'all';
    that.filterPeriod = 'tutti';
    that.type = 'tutti';
    that.pagination = {
      currentPage: {
        number: 0,
        data: []
      },
      pageSize: 10
    };
    that.zipMakeable = [];

    const date = new Date();
    that.start = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
    that.end = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    that.maxDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    that.makePagination = () => {
      that.loading = true;
      that.pagination.elementsCount = that.processedRecord.length;
      that.changePage(0);
      setTimeout(() => { that.loading = false; }, 100);
    };

    that.changePage = (page = 0) => {
      if (that.processedRecord === undefined) return;
      that.pagination.currentPage.number = page;
      const pageStart = page * that.pagination.pageSize;
      const pageEnd = pageStart + that.pagination.pageSize;
      that.pagination.currentPage.data = that.processedRecord.slice(pageStart, pageEnd);
    };

    that.searchText = '';

    that.search = () => {
      that.processedRecord = $filter('filter')(that.movementsList, that.searchText);
      that.makePagination();
    };

    // ==============STUBBONE DA TOGLIERE=======================================
    // that.stubList = [];
    // let time = new Date().getTime();
    // let i = 0;
    // let amount = 0;
    // let direction = '';
    // const cont = 'Mattia Avanzi';
    // let contact = '';
    // for (i = 0; i < 115; i++) {
    //   contact = i === 9 ? 'Gesu' : cont;
    //   direction = i % 2 ? 'in' : 'out';
    //   amount = amount + i / 10;
    //   that.stubList.push({
    //     authTime: time,
    //     transactionId: i,
    //     contact: { name: contact },
    //     amount,
    //     direction
    //   });
    //   time = time - 259200000;
    // }
    // that.movementsList = that.stubList;
    // that.processedRecord = that.movementsList;
    // that.makePagination();
    // ==============FINE STUBBONE DA TOGLIERE==================================

    that.toggleCheck = (value) => {
      value.checked = value.checked ? false : true;  // eslint-disable-line
      if (value.checked) {
        if (that.zipMakeable.indexOf(value.idTransaction) === -1) {
          that.zipMakeable.push(value.idTransaction);
        }
      } else {
        const zipIndex = that.zipMakeable.indexOf(value.idTransaction);
        if (zipIndex > -1) {
          that.zipMakeable.splice(zipIndex, 1);
        }
      }
    };

    that.resetFilter = () => {
      that.filterMonth = 0;
      that.filterType = 'all';
      that.type = 'tutti';
      that.filterPeriod = 'tutti';
      that.getAllMovements();
    };

    that.filter = () => {
      if (that.filterType === 'invoices') {
        that.type = 'fatture';
      } else if (that.filterType === 'notes') {
        that.type = 'note';
      } else {
        that.type = 'tutti';
      }

      switch (that.filterMonth) {
        case '1':
          that.filterPeriod = '1 Mese';
          break;
        case '3':
          that.filterPeriod = '3 Mesi';
          break;
        case '6':
          that.filterPeriod = '6 Mesi';
          break;
        case 'datepicker':
          that.filterPeriod = `Dal ${$filter('amDateFormat')(that.start, 'DD/MM/YYYY')} al ${$filter('amDateFormat')(that.end, 'DD/MM/YYYY')}`;
          break;
        default:
          that.filterPeriod = 'Tutti';
          break;
      }
      that.getMovementsbyFilters(that.filterMonth, that.filterType);
    };

    that.getAllMovements = () => {
      that.loading = true;
      that.movementsList = [];
      InvoicesService.getInvoicesAndNotes(undefined, undefined, wallet).then(
      (data) => {
        that.movementsList = data;
        that.processedRecord = that.movementsList;
        that.makePagination();
      },
      (error) => {
        $log.error(`InvoicesService`, `getListaMovimenti`, error);
        that.loading = false;
      });
    };

    that.getMovementsbyFilters = (month, type) => {
      that.loading = true;
      let dataA = undefined;
      let dataDa = undefined;
      that.movementsList = [];

      if (month !== 'datepicker') {
        if (month) {
          dataA = new Date();
          dataDa = new Date();
          dataDa.setMonth(dataDa.getMonth() - month);
          dataA = dataA.getTime();
          dataDa = dataDa.getTime();
        } else {
          dataA = undefined;
          dataDa = undefined;
        }
      } else {
        dataA = new Date(that.end);
        dataDa = new Date(that.start);
        dataA = dataA.getTime();
        dataDa = dataDa.getTime();
      }

      switch (type) {
        case 'all':
          InvoicesService.getInvoicesAndNotes(dataDa, dataA, wallet).then(
            (data) => {
              that.movementsList = data;
              that.processedRecord = that.movementsList;
              that.makePagination();
            },
            (error) => {
              $log.error(`InvoicesService`, `getListaMovimenti`, error);
              that.loading = false;
            });
          break;
        case 'invoices':
          InvoicesService.getInvoices(dataDa, dataA, wallet).then(
            (data) => {
              that.movementsList = data;
              that.processedRecord = that.movementsList;
              that.makePagination();
            },
            (error) => {
              $log.error(`InvoicesService`, `getListaMovimenti`, error);
              that.loading = false;
            });
          break;
        case 'notes':
          InvoicesService.getNotes(dataDa, dataA, wallet).then(
            (data) => {
              that.movementsList = data;
              that.processedRecord = that.movementsList;
              that.makePagination();
            },
            (error) => {
              $log.error(`InvoicesService`, `getListaMovimenti`, error);
              that.loading = false;
            });
          break;
        default:
          break;
      }
    };

    that.getPdf = (url) => {
      $log.debug('cose da mandare per servizio pdf', url);
      InvoicesService.showPdf(url);
    };

    that.makeZip = () => {
      const checkedList = that.movementsList.filter((o) => o.checked);
      InvoicesService.makeZip(checkedList);
    };

    const loadUserInstrument = () => {
      if (NewUserInstrumentStore.getUserInstrumentListState() === StoreStates.STORE_VALID) {
        wallet = NewUserInstrumentStore.getWallet().idUserInstrument;
        // that.loading.instruments = false;
        that.getAllMovements();
      } else if (NewUserInstrumentStore.getUserInstrumentListState !== StoreStates.STORE_PENDING_UPDATES) {
        // that.loading.instruments = true;
        NewUserInstrumentActions.getUserInstrumentList();
      }
    };

    loadUserInstrument();

    const deregUserInstrumentListUpdateListener = $rootScope.$on('USERINSTRUMENT_ACTION_UPDATE', loadUserInstrument);
    const deregUserInstrumentListFailListener = $rootScope.$on('USERINSTRUMENT_ACTION_UPDATE_FAIL', () => {
      that.loading.instruments = false;
    });

    that.$onDestroy = () => {
      deregUserInstrumentListUpdateListener();
      deregUserInstrumentListFailListener();
    };
  }
}

export default taxationInvoicesController;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/invoices/invoices.controller.js
 **/